import {
  ILoginIncodeResponse,
  ILoginIncodeResponseApi,
} from '../interfaces/incode.interface';

export const incodeLoginResponseAdapter = (
  response: ILoginIncodeResponseApi,
): ILoginIncodeResponse => ({
  userName: response?.username || '',
  roles: response?.roles || [],
  tokenType: response?.token_type || '',
  accessToken: response?.access_token || '',
  expiresIn: response?.expires_in || 0,
  refreshToken: response?.refresh_token || '',
});
